import SingleMarket1Column from '../components/markets/single_market_1_column';
import SingleMarket2Column from '../components/markets/single_market_2_column';
import SingleMarket3Column from '../components/markets/single_market_3_column';

const DefaultMarket = SingleMarket1Column;

/* eslint-disable react/destructuring-assignment */
const Market = (market) => {
  switch (market.layout) {
    case '1-column':
      return <SingleMarket1Column {...market} />;
    case '2-column':
      return <SingleMarket2Column {...market} />;
    case '3-column':
      return <SingleMarket3Column {...market} />;
    default:
      return <DefaultMarket {...market} />;
  }
};

export default Market;
